export default __webpack_public_path__ + "static/spacelove-bitmoji-67d87d9e4e89dbd3795f05bd5caee516.png";